import { type ReactNode, createContext } from 'react'

interface FormValueContextProps {
  formValues?: Record<string, any>
}

interface FormValueProviderProps {
  formValues: Record<string, any>
  children: ReactNode
}

export const FormValueContext = createContext<FormValueContextProps>({})

export const FormValueProvider = ({
  formValues,
  children,
}: FormValueProviderProps) => {
  return (
    <FormValueContext.Provider
      value={{
        formValues,
      }}
    >
      {children}
    </FormValueContext.Provider>
  )
}
